import dayjs from 'dayjs';
import { useRef, useState } from 'react';
import Calendar from 'react-calendar';
import * as S from './styles';
import 'react-calendar/dist/Calendar.css';

interface Props {
  defaultValue?: string | Date | dayjs.Dayjs;
  onChange?: (date: dayjs.Dayjs) => void;
}

export function FibudCalendarV2({ defaultValue, onChange }: Props) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const [selectedDate, setSelectedDate] = useState<Date>(
    dayjs(defaultValue).toDate()
  );
  const calendarRef = useRef();

  return (
    <S.Container>
      <Calendar
        ref={calendarRef}
        value={selectedDate}
        minDetail="year"
        maxDetail="month"
        // tileDisabled={({ date, view }) => view === 'month' && date < today}
        tileContent={({ date, view }) =>
          view === 'month' && (
            <div className="react-calendar--date-num">{date.getDate()}</div>
          )
        }
        onChange={date => {
          setSelectedDate(date as Date);

          if (onChange) {
            onChange(dayjs(date as Date));
          }
        }}
      />
    </S.Container>
  );
}
